import { useI18n } from '@/lib/i18n';
import { OrderPlatform } from '@/types';
import Likes from '@images/Likes.webp';
import LogoCircle from '@images/Logo.svg';
import { usePage } from '@inertiajs/react';

export default function TrialSection() {
  const { t } = useI18n();
  const { props } = usePage<{ title: string; platform: OrderPlatform }>();

  return (
    <section className="relative bg-white">
      <div className="mx-auto max-w-screen-lg sm:p-6 md:py-12 lg:py-20">
        <div className="bg-secondary relative isolate overflow-hidden px-6 pt-12 sm:rounded-3xl sm:px-12 md:flex md:gap-x-20 md:px-24 md:py-24">
          <svg
            viewBox="0 0 1024 1024"
            className="absolute top-1/2 left-1/2 -z-10 size-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 md:left-1/2 md:ml-0 md:-translate-x-1/2 md:translate-y-0"
            aria-hidden="true"
          >
            <circle cx="512" cy="512" r="512" fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fillOpacity="0.7" />
            <defs>
              <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                <stop stopColor="#7775D6" />
                <stop offset="1" stopColor="#E935C1" />
              </radialGradient>
            </defs>
          </svg>
          <div className="mx-auto max-w-md text-center md:mx-0 md:flex-auto md:text-left">
            <h2 className="text-3xl font-semibold tracking-tight text-balance text-black sm:text-4xl">
              {t('layout.Not sure? Try out for free first!', { service: props.title })}
            </h2>
            <p className="mt-6 text-lg/8 text-pretty text-orange-950">{t('layout.trial_likes_text')}</p>
            <div className="mt-10 flex items-center justify-center gap-x-6 md:justify-start">
              <a
                href={route(`${props.platform}.trial`)}
                className="rounded-xl bg-white px-4 py-3 font-bold text-black shadow-xs hover:opacity-75"
                rel={isSubdomain ? 'nofollow' : undefined}
              >
                {t('layout.Try for free')} &rarr;
              </a>
            </div>
          </div>

          <div className="right-0 bottom-0 mx-auto mt-8 -mb-8 w-10/12 rotate-6 overflow-auto rounded-t-3xl sm:max-w-sm md:absolute md:mx-8 md:-mb-8 md:w-2xs lg:w-sm">
            <div className="relative">
              <img src={LogoCircle} alt="Boostbuddy" className={'absolute top-0 right-0 z-10 m-3 w-12 md:w-12'} />
              <img className="w-full object-cover contrast-125" src={Likes} alt="Gratis likes" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
